export default () => ({
  pickedIsCompany: false,
  invoiceIsCompany: false,

  init() {
    this.pickedIsCompany = this.$el.dataset.pickedCompany === 'true'
    this.invoiceIsCompany = this.$el.dataset.invoiceCompany === 'true'

    this.onAddressPickerChange = this.onAddressPickerChange.bind(this)
    window.addEventListener('address-picker:change', this.onAddressPickerChange)
  },

  destroy() {
    window.removeEventListener(
      'address-picker:change',
      this.onAddressPickerChange,
    )
  },

  onAddressPickerChange(event) {
    if (event.detail.kind !== 'delivery') return
    this.pickedIsCompany = !!event.detail.is_company
    this.$el.dataset.pickedCompany = String(this.pickedIsCompany)
  },

  get showFaoField() {
    return (
      (this.delivery_type == 'leveren' && this.pickedIsCompany) ||
      (this.delivery_type == 'leveren_idem' && this.invoiceIsCompany)
    )
  },
})
